import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Observable } from 'rxjs';
import noop from 'lodash/noop';

const propTypes = {
  className: PropTypes.string,
  defaultValue: PropTypes.number,
  ticksAmount: PropTypes.number.isRequired,
  intervalBetweenTicks: PropTypes.number.isRequired,
  reverse: PropTypes.bool,
  restartTimer: PropTypes.bool, // todo: [Igor] probably remove

  timeValueFormatter: PropTypes.func,
  onChange: PropTypes.func,
  onComplete: PropTypes.func,
};

const defaultProps = {
  className: '',
  defaultValue: 0,
  reverse: false,
  restartTimer: false,

  timeValueFormatter: (value) => value,
  onChange: noop,
  onComplete: noop,
};

class TimerWithReactive extends Component {

  state = {
    timeValue: 0,
  };

  componentDidMount() {
    this.startTimer();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.restartTimer !== this.props.restartTimer &&
        nextProps.restartTimer === true
    ) {
      this.restartTimer();
    }
  }

  componentWillUnmount() {
    this.timer$.unsubscribe();
  }

  startTimer = () => {
    const {
      defaultValue,
      ticksAmount,
      intervalBetweenTicks,
      reverse,
      onChange,
      onComplete,
    } = this.props;

    const currentTick = defaultValue || (reverse ? ticksAmount : 0);
    const startTime = Date.now();

    const getTick = () => {
      const thisTick = Math.floor((Date.now() - startTime) / intervalBetweenTicks);
      return reverse ? currentTick - thisTick : currentTick + thisTick;
    };
    const setTimeValue = (value) => this.setState({ timeValue: value });

    setTimeValue(getTick());

    this.timer$ = Observable
      .interval(intervalBetweenTicks)
      .takeUntil(Observable.timer(currentTick * intervalBetweenTicks))
      .map(getTick)
      .do(onChange)
      .finally(onComplete)
      .subscribe(setTimeValue);
  };

  restartTimer = () => {
    this.startTimer();
  };

  render() {
    const { timeValueFormatter } = this.props;
    const { timeValue } = this.state;

    return (
      <span className={ this.props.className }>
        { timeValueFormatter(timeValue) }
      </span>
    );
  }
}

TimerWithReactive.propTypes = propTypes;
TimerWithReactive.defaultProps = defaultProps;

export default TimerWithReactive;
